<template>
  <div class="h-100 border-right border-left border-light">
    <b-nav vertical class="text-dark supplier-nav-left sticky-top w-100 min-vh-100">
      <b-nav-item
        link-classes="py-4 border-bottom border-light text-dark d-flex"
        :to="{ name: 'home' }"
      >
        <div class="link-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="17"
            viewBox="0 0 24 17"
            fill="#363636"
          >
            <path
              fill-rule="evenodd"
              d="M23.904,4.325 L23.118,3.249
          L23.905,2.164 C24.032,1.988 24.031,1.751 23.904,1.576 L22.904,0.206 C22.81,0.076 22.66,0
          22.5,0 L5.5,0 C4.673,0 4,0.673 4,1.5 L4,5 L1.5,5 C0.673,5 0,5.673 0,6.5 L0,15.5 C0,16.327
          0.673,17 1.5,17 L18.5,17 C18.66,17 18.811,16.923 18.904,16.793 L19.904,15.415
          C20.032,15.24 20.032,15.003 19.904,14.828 L19.118,13.743 L19.904,12.66 C20.032,12.485
          20.032,12.247 19.904,12.072 L19.852,12 L22.5,12 C22.66,12 22.811,11.923 22.905,11.793
          L23.905,10.413 C24.031,10.238 24.031,10.001 23.905,9.826 L23.118,8.741 L23.904,7.665
          C24.031,7.49 24.032,7.252 23.905,7.077 L23.118,5.992 L23.904,4.916 C24.032,4.739
          24.032,4.501 23.904,4.325 L23.904,4.325 Z M5,1.5 C5,1.224 5.225,1 5.5,1 L10,1 L10,5 L5,5
          L5,1.5 L5,1.5 Z M1,15.5 L1,6.5 C1,6.224 1.225,6 1.5,6 L6,6 L6,16 L1.5,16 C1.225,16
          1,15.776 1,15.5 L1,15.5 Z M18.096,14.037 L18.882,15.122 L18.245,16 L7,16 L7,6 L18.245,6
          L18.882,6.874 L18.096,7.952 C17.968,8.127 17.968,8.365 18.096,8.541 L18.882,9.62
          L18.096,10.7 C17.968,10.875 17.968,11.113 18.096,11.288 L18.882,12.367 L18.096,13.449
          C17.968,13.625 17.968,13.861 18.096,14.037 L18.096,14.037 Z M22.245,11 L19.123,11
          L19.118,10.994 L19.904,9.913 C20.032,9.738 20.032,9.5 19.904,9.325 L19.118,8.246
          L19.904,7.169 C20.032,6.994 20.032,6.756 19.904,6.58 L18.904,5.206 C18.811,5.077 18.66,5
          18.5,5 L11,5 L11,1 L22.246,1 L22.882,1.871 L22.095,2.956 C21.968,3.132 21.969,3.369
          22.096,3.544 L22.881,4.619 L22.096,5.694 C21.969,5.869 21.968,6.107 22.095,6.282
          L22.882,7.367 L22.096,8.443 C21.969,8.618 21.968,8.856 22.095,9.031 L22.883,10.117
          L22.245,11 L22.245,11 Z"
            />
          </svg>
        </div>
        <span>Verdibevis</span>
      </b-nav-item>
      <b-nav-item
        link-classes="py-4 border-bottom border-light text-dark d-flex w-100"
        :to="{ name: 'invoices' }"
      >
        <div class="link-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="24"
            viewBox="0 0 16 24"
            fill="#363636"
          >
            <g fill-rule="evenodd" transform="translate(0 -1)">
              <path
                d="M0.735,24.941 L2.38,24.066 L4.025,24.941
            C4.098,24.98 4.179,25 4.259,25 C4.339,25 4.421,24.98 4.494,24.941 L6.136,24.066
            L7.773,24.94 C7.919,25.019 8.096,25.019 8.244,24.94 L9.884,24.065 L11.522,24.939
            C11.668,25.018 11.846,25.018 11.993,24.939 L13.627,24.065 L15.265,24.939 C15.42,25.022
            15.607,25.017 15.758,24.927 C15.908,24.838 16,24.676 16,24.5 L16,1.5 C16,1.324
            15.908,1.162 15.757,1.071 C15.606,0.981 15.42,0.975 15.265,1.058 L13.62,1.934
            L11.975,1.059 C11.829,0.981 11.652,0.981 11.505,1.059 L9.863,1.934 L8.226,1.06
            C8.08,0.981 7.903,0.981 7.755,1.06 L6.115,1.935 L4.479,1.059 C4.333,0.98 4.155,0.98
            4.008,1.059 L2.374,1.933 L0.735,1.059 C0.581,0.976 0.394,0.981 0.243,1.071 C0.092,1.162
            0,1.324 0,1.5 L0,24.5 C0,24.676 0.092,24.838 0.243,24.929 C0.393,25.019 0.578,25.023
            0.735,24.941 L0.735,24.941 Z M1,2.333 L2.138,2.94 C2.285,3.019 2.462,3.019 2.609,2.94
            L4.243,2.066 L5.881,2.94 C6.027,3.019 6.204,3.019 6.352,2.94 L7.992,2.065 L9.629,2.939
            C9.775,3.019 9.953,3.018 10.099,2.939 L11.741,2.064 L13.386,2.939 C13.532,3.017
            13.709,3.017 13.856,2.939 L15,2.333 L15,23.667 L13.862,23.06 C13.715,22.981
            13.538,22.981 13.391,23.06 L11.757,23.934 L10.119,23.06 C9.973,22.981 9.796,22.981
            9.648,23.06 L8.008,23.935 L6.371,23.061 C6.225,22.982 6.048,22.983 5.901,23.061
            L4.259,23.936 L2.614,23.061 C2.542,23.02 2.46,23 2.38,23 C2.3,23 2.218,23.02
            2.145,23.059 L1,23.667 L1,2.333 L1,2.333 Z"
              />
              <path
                d="M3.5 7L8.5 7C8.776 7 9 6.776 9 6.5 9 6.224 8.776 6
            8.5 6L3.5 6C3.224 6 3 6.224 3 6.5 3 6.776 3.224 7 3.5 7L3.5 7zM3.5 11L12.5 11C12.776 11
            13 10.776 13 10.5 13 10.224 12.776 10 12.5 10L3.5 10C3.224 10 3 10.224 3 10.5 3 10.776
            3.224 11 3.5 11L3.5 11zM3.5 14L12.5 14C12.776 14 13 13.776 13 13.5 13 13.224 12.776 13
            12.5 13L3.5 13C3.224 13 3 13.224 3 13.5 3 13.776 3.224 14 3.5 14L3.5 14zM3.5 17L12.5
            17C12.776 17 13 16.776 13 16.5 13 16.224 12.776 16 12.5 16L3.5 16C3.224 16 3 16.224 3
            16.5 3 16.776 3.224 17 3.5 17L3.5 17zM3.5 20L9.5 20C9.776 20 10 19.776 10 19.5 10 19.224
            9.776 19 9.5 19L3.5 19C3.224 19 3 19.224 3 19.5 3 19.776 3.224 20 3.5 20L3.5 20zM12.5
            19L11.5 19C11.224 19 11 19.224 11 19.5 11 19.776 11.224 20 11.5 20L12.5 20C12.776 20 13
            19.776 13 19.5 13 19.224 12.776 19 12.5 19L12.5 19z"
              />
            </g>
          </svg>
        </div>

        <span>Oppgjør</span>
        <b-badge variant="primary" pill class="small round">
          {{ nextInvoiceCount.length }}
        </b-badge>
      </b-nav-item>
      <b-nav-item
          v-if="user.supplier.dash_date_activated"
        link-classes="py-4 border-bottom border-light text-dark d-flex w-100"
        :to="{ name: 'bookings' }"
      >
        <div class="link-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="19"
            viewBox="0 0 20 19"
            fill="#363636"
          >
            <g>
              <path
                d="M19.5833333,1.66666667 L16.6666667,1.66666667 L16.6666667,0.416666667 C16.6666667,0.186666667 16.48,0 16.25,0 C16.02,0 15.8333333,0.186666667 15.8333333,0.416666667 L15.8333333,1.66666667 L12.5,1.66666667 L12.5,0.416666667 C12.5,0.186666667 12.3133333,0 12.0833333,0 C11.8533333,0 11.6666667,0.186666667 11.6666667,0.416666667 L11.6666667,1.66666667 L8.33333333,1.66666667 L8.33333333,0.416666667 C8.33333333,0.186666667 8.14666667,0 7.91666667,0 C7.68666667,0 7.5,0.186666667 7.5,0.416666667 L7.5,1.66666667 L4.16666667,1.66666667 L4.16666667,0.416666667 C4.16666667,0.186666667 3.98,0 3.75,0 C3.52,0 3.33333333,0.186666667 3.33333333,0.416666667 L3.33333333,1.66666667 L0.416666667,1.66666667 C0.186666667,1.66666667 0,1.85333333 0,2.08333333 L0,17.9166667 C0,18.1466667 0.186666667,18.3333333 0.416666667,18.3333333 L19.5833333,18.3333333 C19.8133333,18.3333333 20,18.1466667 20,17.9166667 L20,2.08333333 C20,1.85333333 19.8133333,1.66666667 19.5833333,1.66666667 Z M3.33333333,2.5 L3.33333333,2.91666667 C3.33333333,3.14666667 3.52,3.33333333 3.75,3.33333333 C3.98,3.33333333 4.16666667,3.14666667 4.16666667,2.91666667 L4.16666667,2.5 L7.5,2.5 L7.5,2.91666667 C7.5,3.14666667 7.68666667,3.33333333 7.91666667,3.33333333 C8.14666667,3.33333333 8.33333333,3.14666667 8.33333333,2.91666667 L8.33333333,2.5 L11.6666667,2.5 L11.6666667,2.91666667 C11.6666667,3.14666667 11.8533333,3.33333333 12.0833333,3.33333333 C12.3133333,3.33333333 12.5,3.14666667 12.5,2.91666667 L12.5,2.5 L15.8333333,2.5 L15.8333333,2.91666667 C15.8333333,3.14666667 16.02,3.33333333 16.25,3.33333333 C16.48,3.33333333 16.6666667,3.14666667 16.6666667,2.91666667 L16.6666667,2.5 L19.1666667,2.5 L19.1666667,5 L0.833333333,5 L0.833333333,2.5 L3.33333333,2.5 Z M0.833333333,17.5 L0.833333333,5.83333333 L19.1666667,5.83333333 L19.1666667,17.5 L0.833333333,17.5 Z"
              ></path>
              <path
                d="M5.91666667 7L3.41666667 7C3.18666667 7 3 7.18666667 3 7.41666667L3 9.91666667C3 10.1466667 3.18666667 10.3333333 3.41666667 10.3333333L5.91666667 10.3333333C6.14666667 10.3333333 6.33333333 10.1466667 6.33333333 9.91666667L6.33333333 7.41666667C6.33333333 7.18666667 6.14666667 7 5.91666667 7zM5.5 9.5L3.83333333 9.5 3.83333333 7.83333333 5.5 7.83333333 5.5 9.5zM15.9166667 7L13.4166667 7C13.1866667 7 13 7.18666667 13 7.41666667L13 9.91666667C13 10.1466667 13.1866667 10.3333333 13.4166667 10.3333333L15.9166667 10.3333333C16.1466667 10.3333333 16.3333333 10.1466667 16.3333333 9.91666667L16.3333333 7.41666667C16.3333333 7.18666667 16.1466667 7 15.9166667 7zM15.5 9.5L13.8333333 9.5 13.8333333 7.83333333 15.5 7.83333333 15.5 9.5zM10.9166667 7L8.41666667 7C8.18666667 7 8 7.18666667 8 7.41666667L8 9.91666667C8 10.1466667 8.18666667 10.3333333 8.41666667 10.3333333L10.9166667 10.3333333C11.1466667 10.3333333 11.3333333 10.1466667 11.3333333 9.91666667L11.3333333 7.41666667C11.3333333 7.18666667 11.1466667 7 10.9166667 7zM10.5 9.5L8.83333333 9.5 8.83333333 7.83333333 10.5 7.83333333 10.5 9.5zM5.91666667 12L3.41666667 12C3.18666667 12 3 12.1866667 3 12.4166667L3 14.9166667C3 15.1466667 3.18666667 15.3333333 3.41666667 15.3333333L5.91666667 15.3333333C6.14666667 15.3333333 6.33333333 15.1466667 6.33333333 14.9166667L6.33333333 12.4166667C6.33333333 12.1866667 6.14666667 12 5.91666667 12zM5.5 14.5L3.83333333 14.5 3.83333333 12.8333333 5.5 12.8333333 5.5 14.5zM15.9166667 12L13.4166667 12C13.1866667 12 13 12.1866667 13 12.4166667L13 14.9166667C13 15.1466667 13.1866667 15.3333333 13.4166667 15.3333333L15.9166667 15.3333333C16.1466667 15.3333333 16.3333333 15.1466667 16.3333333 14.9166667L16.3333333 12.4166667C16.3333333 12.1866667 16.1466667 12 15.9166667 12zM15.5 14.5L13.8333333 14.5 13.8333333 12.8333333 15.5 12.8333333 15.5 14.5zM10.9166667 12L8.41666667 12C8.18666667 12 8 12.1866667 8 12.4166667L8 14.9166667C8 15.1466667 8.18666667 15.3333333 8.41666667 15.3333333L10.9166667 15.3333333C11.1466667 15.3333333 11.3333333 15.1466667 11.3333333 14.9166667L11.3333333 12.4166667C11.3333333 12.1866667 11.1466667 12 10.9166667 12zM10.5 14.5L8.83333333 14.5 8.83333333 12.8333333 10.5 12.8333333 10.5 14.5z"
              ></path>
            </g>
          </svg>
        </div>
        <span>Bookingsystem</span>
      </b-nav-item>
      <b-nav-item
            ref="accountInformation"
            link-classes="py-4 border-bottom border-light text-dark d-flex w-100 justify-content-between align-items-center"
            @click.stop="toggleAccountInformation"
        >
            <div class="d-flex align-items-center">
                <div class="link-icon">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        :fill="accountInformationActive ? '#17C27C' : '#363636'"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M12,0 C5.383,0 0,5.383 0,12
    C0,14.977 1.101,17.831 3.098,20.035 C3.098,20.035 3.098,20.035 3.098,20.036 L3.099,20.037
    L3.099,20.037 L3.099,20.037 C5.371,22.555 8.615,24 12,24 C15.417,24 18.685,22.532
    20.963,19.973 C20.963,19.973 20.963,19.972 20.964,19.971 C22.922,17.775 24,14.944 24,12
    C24,5.383 18.617,0 12,0 L12,0 Z M12,23 C8.986,23 6.094,21.75 4.022,19.562 L4.768,16.678
    C4.983,15.706 5.943,15 7.05,15 L9.6,15 C10.372,15 11,14.372 11,13.546 C11,13.099
    10.778,12.678 10.391,12.392 C8.581,11.049 8.44,8.431 8.44,7.66 C8.44,5.197 9.591,4 11.96,4
    C14.369,4 15.59,5.231 15.59,7.66 C15.59,9.239 15.07,11.31 13.61,12.391 C13.222,12.678
    13,13.1 13,13.6 C13,14.372 13.628,15 14.4,15 L17.14,15 C18.247,15 19.206,15.706
    19.422,16.678 L20.046,19.495 C17.966,21.726 15.048,23 12,23 L12,23 Z M20.854,18.522
    L20.398,16.462 C20.078,15.012 18.738,14 17.14,14 L14.4,14 C14.179,14 14,13.82 14,13.547
    C14,13.366 14.143,13.241 14.205,13.195 C16.418,11.556 16.59,8.544 16.59,7.66 C16.59,4.699
    14.902,3 11.96,3 C9.045,3 7.44,4.655 7.44,7.66 C7.44,8.549 7.61,11.574 9.795,13.195
    C9.857,13.241 10,13.366 10,13.6 C10,13.82 9.82,14 9.6,14 L7.05,14 C5.452,14 4.112,15.012
    3.796,16.445 L3.232,18.627 C1.788,16.727 1,14.408 1,12 C1,5.935 5.935,1 12,1 C18.065,1
    23,5.935 23,12 C23,14.36 22.244,16.64 20.854,18.522 L20.854,18.522 Z"
                        />
                    </svg>
                </div>
                <span class="ml-2">Kontoopplysninger</span>
            </div>
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                :style="{ transform: accountInformationActive ? 'rotate(0deg)' : 'rotate(90deg)' }"
            >
                <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
            </svg>
        </b-nav-item>
      <div v-if="accountInformationActive">
            <router-link :to="{ name: 'products' }" class="text-decoration-none">
                <div class="py-2 border-light text-dark d-flex w-100 hoverable">
                    <span class="ml-3">Opplevelser</span>
                </div>
            </router-link>
            <router-link :to="{ name: 'companyInfo' }" class="text-decoration-none">
                <div class="py-2 border-light text-dark d-flex w-100 hoverable">
                    <span class="ml-3">Bedriftsopplysninger</span>
                </div>
            </router-link>
            <router-link :to="{ name: 'userInfo' }" class="text-decoration-none">
                <div class="py-2 border-light text-dark d-flex w-100 hoverable">
                    <span class="ml-3">Brukeropplysninger</span>
                </div>
            </router-link>
        </div>

      <b-nav-item
            ref="quickGuideItem"
            link-classes="py-4 border-bottom border-light text-dark d-flex w-100 justify-content-between align-items-center"
            @click.stop="toggleQuickGuide"
        >
            <div class="d-flex align-items-center">
                <div class="link-icon">
                    <svg width="28" height="28" viewBox="0 0 65 74" :fill="quickGuideActive ? '#17C27C' : '#363636'" xmlns="http://www.w3.org/2000/svg">
                        <path d="M54.63 63.65C54.63 64.009 54.339 64.3 53.98 64.3C53.621 64.3 53.33 64.009 53.33 63.65C53.33 63.291 53.621 63 53.98 63C54.339 63 54.63 63.291 54.63 63.65Z"/>
                        <path d="M54.65 51C54.65 50.641 54.359 50.35 54 50.35C53.641 50.35 53.35 50.641 53.35 51H54.65ZM53.35 61C53.35 61.359 53.641 61.65 54 61.65C54.359 61.65 54.65 61.359 54.65 61H53.35ZM1 1.5V0.85H0.35V1.5H1ZM1 72.5H0.35V73.15H1V72.5ZM54.5 72.5V73.15H55.15V72.5H54.5ZM54.5 1.5H55.15V0.85H54.5V1.5ZM10 11.35C9.64101 11.35 9.35 11.641 9.35 12C9.35 12.359 9.64101 12.65 10 12.65V11.35ZM46 12.65C46.359 12.65 46.65 12.359 46.65 12C46.65 11.641 46.359 11.35 46 11.35V12.65ZM10 21.35C9.64101 21.35 9.35 21.641 9.35 22C9.35 22.359 9.64101 22.65 10 22.65V21.35ZM46 22.65C46.359 22.65 46.65 22.359 46.65 22C46.65 21.641 46.359 21.35 46 21.35V22.65ZM10 31.35C9.64101 31.35 9.35 31.641 9.35 32C9.35 32.359 9.64101 32.65 10 32.65V31.35ZM46 32.65C46.359 32.65 46.65 32.359 46.65 32C46.65 31.641 46.359 31.35 46 31.35V32.65ZM10 41.35C9.64101 41.35 9.35 41.641 9.35 42C9.35 42.359 9.64101 42.65 10 42.65V41.35ZM46 42.65C46.359 42.65 46.65 42.359 46.65 42C46.65 41.641 46.359 41.35 46 41.35V42.65ZM10 51.35C9.64101 51.35 9.35 51.641 9.35 52C9.35 52.359 9.64101 52.65 10 52.65V51.35ZM40 52.65C40.359 52.65 40.65 52.359 40.65 52C40.65 51.641 40.359 51.35 40 51.35V52.65ZM10 61.35C9.64101 61.35 9.35 61.641 9.35 62C9.35 62.359 9.64101 62.65 10 62.65V61.35ZM40 62.65C40.359 62.65 40.65 62.359 40.65 62C40.65 61.641 40.359 61.35 40 61.35V62.65ZM63.35 58C63.35 63.1639 59.1639 67.35 54 67.35V68.65C59.8818 68.65 64.65 63.8818 64.65 58H63.35ZM54 67.35C48.8361 67.35 44.65 63.1639 44.65 58H43.35C43.35 63.8818 48.1182 68.65 54 68.65V67.35ZM44.65 58C44.65 52.8361 48.8361 48.65 54 48.65V47.35C48.1182 47.35 43.35 52.1182 43.35 58H44.65ZM54 48.65C59.1639 48.65 63.35 52.8361 63.35 58H64.65C64.65 52.1182 59.8818 47.35 54 47.35V48.65ZM53.35 51V61H54.65V51H53.35ZM53.98 63.65L53.98 63.65V64.95C54.698 64.95 55.28 64.368 55.28 63.65H53.98ZM53.98 63.65L53.98 63.65H52.68C52.68 64.368 53.262 64.95 53.98 64.95V63.65ZM53.98 63.65L53.98 63.65V62.35C53.262 62.35 52.68 62.932 52.68 63.65H53.98ZM53.98 63.65L53.98 63.65H55.28C55.28 62.932 54.698 62.35 53.98 62.35V63.65ZM0.35 1.5V72.5H1.65V1.5H0.35ZM1 73.15H54.5V71.85H1V73.15ZM55.15 72.5V68.5H53.85V72.5H55.15ZM1 2.15H54.5V0.85H1V2.15ZM53.85 1.5V48H55.15V1.5H53.85ZM10 12.65H46V11.35H10V12.65ZM10 22.65H46V21.35H10V22.65ZM10 32.65H46V31.35H10V32.65ZM10 42.65H46V41.35H10V42.65ZM10 52.65H40V51.35H10V52.65ZM10 62.65H40V61.35H10V62.65Z"/>
                    </svg>
                </div>
                <span class="ml-2">Quick guide</span>
            </div>
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                :style="{ transform: quickGuideActive ? 'rotate(0deg)' : 'rotate(90deg)' }"
            >
                <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
            </svg>
        </b-nav-item>
      <div v-if="quickGuideActive">
            <router-link :to="{ name: 'certificateOfValue' }" class="text-decoration-none">
                <div class="py-2 border-light text-dark d-flex w-100 hoverable">
                    <span class="ml-3">Løs inn gavekort/verdibevis</span>
                </div>
            </router-link>
            <router-link :to="{ name: 'Settlement' }" class="text-decoration-none">
                <div class="py-2 border-light text-dark d-flex w-100 hoverable">
                    <span class="ml-3">Oppgjør</span>
                </div>
            </router-link>
            <router-link :to="{ name: 'YouWishPartnerPortal' }" class="text-decoration-none">
                <div class="py-2 border-light text-dark d-flex w-100 hoverable">
                    <span class="ml-3">YouWish partner portal</span>
                </div>
            </router-link>
          <a href="/supplier/vanlige" class="text-decoration-none">
              <div class="py-2 border-light text-dark d-flex w-100 hoverable">
                  <component :is="isFAQActive ? 'strong' : 'span'" class="ml-3">
                      Vanlige spørsmål
                  </component>
              </div>
          </a>
            <router-link :to="{ name: 'LoginOrResetPassword' }" class="text-decoration-none">
                <div class="py-2 border-light text-dark d-flex w-100 hoverable">
                    <span class="ml-3">Login og glemt passord</span>
                </div>
            </router-link>
        </div>

        <b-nav-item
            ref="knowledgeBaseItem"
            link-classes="py-4 border-bottom border-light text-dark d-flex w-100 justify-content-between align-items-center"
            @click.stop="toggleKnowledgeBase"
        >
            <div class="d-flex align-items-center">
                <div class="link-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" height="30px" width="30px" viewBox="0 -960 960 960" :fill="knowledgeBaseActive ? '#17C27C' : '#1f1f1f'" >
                        <path d="M464.05-300h33.85v-220h-33.85v220Zm15.94-274.97q9.5 0 16.01-6.32 6.51-6.31 6.51-16.04 0-9.79-6.5-16.23-6.5-6.44-16-6.44-10.01 0-16.27 6.44-6.25 6.44-6.25 16.23 0 9.73 6.5 16.04 6.5 6.32 16 6.32Zm.32 454.97q-75.01 0-140.33-28.34-65.33-28.34-114.29-77.25-48.96-48.92-77.32-114.23Q120-405.14 120-480.2q0-74.55 28.34-140.18 28.34-65.63 77.25-114.26 48.92-48.63 114.23-76.99Q405.14-840 480.2-840q74.55 0 140.18 28.34 65.63 28.34 114.26 76.92 48.63 48.58 76.99 114.26Q840-554.81 840-480.31q0 75.01-28.34 140.33-28.34 65.33-76.92 114.16-48.58 48.84-114.26 77.33Q554.81-120 480.31-120Zm.02-33.85q135.93 0 230.88-95.02 94.94-95.03 94.94-231.46 0-135.93-94.82-230.88-94.82-94.94-231.33-94.94-136.1 0-231.13 94.82-95.02 94.82-95.02 231.33 0 136.1 95.02 231.13 95.03 95.02 231.46 95.02ZM480-480Z"/>
                    </svg>
                </div>
                <span class="ml-2">Kunskapsbase</span>
            </div>
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                :style="{ transform: knowledgeBaseActive ? 'rotate(0deg)' : 'rotate(90deg)' }"
            >
                <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
            </svg>
        </b-nav-item>
        <div v-if="knowledgeBaseActive">
            <router-link :to="{ name: 'IncreaseSales' }" class="text-decoration-none">
                <div class="py-2 border-light text-dark d-flex w-100 hoverable">
                    <span class="ml-3">Øk salget hos YouWish.no</span>
                </div>
            </router-link>
            <router-link :to="{ name: 'ExperienceProducts' }" class="text-decoration-none">
                <div class="py-2 border-light text-dark d-flex w-100 hoverable">
                    <span class="ml-3">Opplevelsesprodukter</span>
                </div>
            </router-link>
            <router-link v-if="user.supplier.dash_date_activated" :to="{ name: 'bookings' }" class="text-decoration-none">
                <div class="py-2 border-light text-dark d-flex w-100 hoverable">
                    <span class="ml-3">Booking</span>
                </div>
            </router-link>
            <router-link :to="{ name: 'bookings' }" class="text-decoration-none">
                <div class="py-2 border-light text-dark d-flex w-100 hoverable">
                    <span class="ml-3">Regnskapsbilag</span>
                </div>
            </router-link>
            <router-link :to="{ name: 'CustomerPolicy' }" class="text-decoration-none">
                <div class="py-2 border-light text-dark d-flex w-100 hoverable">
                    <span class="ml-3">Policy for kunder</span>
                </div>
            </router-link>
        </div>

      <b-nav-text
        link-classes="py-4 border-bottom border-light text-dark d-flex"
        :to="{ name: 'home' }"
      >
        <div class="mt-2 mt-lg-5 px-3">
          <a href="#" @click.prevent="backToUser" class="text-danger small" v-if="impersonator">Log back in as {{ impersonator }}</a>
          <a href="#" @click.prevent="signOut" class="text-danger small" v-else>Logg ut</a>

          <div class="mt-3">
            <h6>Support</h6>
            <ul class="list-unstyled mt-2">
              <li>
                <svg
                  class="d-none d-lg-inline mr-2"
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="12"
                  viewBox="0 0 16 12"
                  fill="#363636"
                >
                  <path
                    d="M15.976,0.213333333 C15.9666667,0.188666667 15.9513333,0.168666667 15.9366667,0.148 C15.928,0.135333333 15.924,0.120666667 15.9133333,0.108666667 C15.912,0.106666667 15.9093333,0.106 15.908,0.104666667 C15.8893333,0.0853333333 15.866,0.072 15.8433333,0.0573333333 C15.8293333,0.0486666667 15.8173333,0.036 15.802,0.0293333333 C15.7846667,0.022 15.7653333,0.0206666667 15.7466667,0.016 C15.7226667,0.01 15.6993333,0.002 15.6753333,0.00133333333 C15.672,0.00133333333 15.6693333,0 15.6666667,0 L0.333333333,0 C0.330666667,0 0.328666667,0.00133333333 0.326,0.00133333333 C0.302,0.002 0.28,0.01 0.256666667,0.0153333333 C0.237333333,0.02 0.216666667,0.0213333333 0.198,0.03 C0.185333333,0.0353333333 0.174666667,0.0466666667 0.162,0.054 C0.137333333,0.0693333333 0.112666667,0.084 0.0926666667,0.104666667 C0.0913333333,0.106666667 0.0886666667,0.106666667 0.0873333333,0.108666667 C0.0766666667,0.120666667 0.0726666667,0.135333333 0.064,0.148 C0.0493333333,0.169333333 0.0333333333,0.189333333 0.024,0.213333333 C0.0153333333,0.236666667 0.0133333333,0.261333333 0.00933333333,0.286 C0.00733333333,0.302 0,0.316666667 0,0.333333333 L0,11.6666667 C0,11.8506667 0.149333333,12 0.333333333,12 L15.6666667,12 C15.8506667,12 16,11.8506667 16,11.6666667 L16,0.333333333 C16,0.316666667 15.9926667,0.302 15.9906667,0.286 C15.9866667,0.261333333 15.9846667,0.236666667 15.976,0.213333333 Z M14.8073333,0.666666667 L8,6.882 L1.19266667,0.666666667 L14.8073333,0.666666667 Z M0.666666667,11.3333333 L0.666666667,1.08866667 L7.77533333,7.57933333 C7.83933333,7.63733333 7.91933333,7.66666667 8,7.66666667 C8.08066667,7.66666667 8.16066667,7.63733333 8.22466667,7.57933333 L15.3333333,1.08866667 L15.3333333,11.3333333 L0.666666667,11.3333333 Z"
                  />
                </svg>
                <a class="font-weight-light" href="mailto: support@youwish.no"
                  ><span>support@youwish.no</span></a
                >
              </li>
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  class="d-none d-lg-inline mr-2"
                >
                  <g fill="#363636">
                    <path
                      d="M.396666667 8.09733333C1.064 9.39466667 2.05666667 10.778 3.192 11.9913333 4.14933333 13.014 5.22933333 13.9193333 6.40133333 14.6813333L6.566 14.7886667C7.43533333 15.3566667 8.42 16 9.56066667 16 9.56133333 16 9.58066667 16 9.58133333 16 10.5273333 15.9933333 11.454 15.6066667 12.1233333 14.9373333L13.0453333 14.0166667C13.4286667 13.6326667 13.4286667 13.008 13.0453333 12.624L11.2033333 10.7826667C10.8313333 10.4106667 10.1826667 10.41 9.81066667 10.7826667L8.622 11.9706667C8.516 12.0766667 8.33533333 12.096 8.21533333 12.0133333 6.55666667 10.8653333 5.13266667 9.442 3.984 7.78333333 3.89933333 7.66066667 3.91733333 7.486 4.02666667 7.37666667L5.21533333 6.18866667C5.40133333 6.00266667 5.504 5.75533333 5.504 5.49266667 5.504 5.22933333 5.40133333 4.982 5.21533333 4.79666667L3.37266667 2.95466667C3 2.584 2.352 2.58333333 1.98 2.95466667L1.05866667 3.876C.891333333 4.04333333.738666667 4.22866667.606666667 4.42733333-.114 5.504-.196 6.94533333.396666667 8.09733333zM1.16066667 4.79733333C1.26933333 4.63533333 1.39333333 4.484 1.53 4.34733333L2.45133333 3.42666667C2.51133333 3.36666667 2.59133333 3.33333333 2.67666667 3.33333333 2.762 3.33333333 2.842 3.36666667 2.90133333 3.42666667L4.744 5.26866667C4.804 5.32866667 4.83733333 5.408 4.83733333 5.49333333 4.83733333 5.57866667 4.804 5.658 4.744 5.718L3.55533333 6.906C3.216 7.24533333 3.166 7.774 3.43533333 8.16333333 4.63 9.888 6.11 11.368 7.83533333 12.562 7.998 12.6746667 8.18933333 12.734 8.38866667 12.734 8.65133333 12.734 8.908 12.6273333 9.09333333 12.442L10.282 11.254C10.4026667 11.1333333 10.6113333 11.1333333 10.732 11.254L12.574 13.0953333C12.698 13.2193333 12.698 13.4213333 12.574 13.5453333L11.6526667 14.466C11.1066667 15.012 10.35 15.328 9.57733333 15.3333333L9.56133333 15.6666667 9.56133333 15.3333333C8.61933333 15.3333333 7.76133333 14.7726667 6.93133333 14.2306667L6.76533333 14.122C5.638 13.3893333 4.59933333 12.5193333 3.67933333 11.536 2.58466667 10.3666667 1.63 9.03733333.99 7.79266667.506 6.852.572666667 5.67666667 1.16066667 4.79733333zM9.33333333 0C9.14933333 0 9 .149333333 9 .333333333 9 .517333333 9.14933333.666666667 9.33333333.666666667 12.6413333.666666667 15.3333333 3.35866667 15.3333333 6.66666667 15.3333333 6.85066667 15.4826667 7 15.6666667 7 15.8506667 7 16 6.85066667 16 6.66666667 16 2.99066667 13.0093333 0 9.33333333 0z"
                    />
                    <path
                      d="M13.3333333,6.66666667 C13.3333333,6.85066667 13.4826667,7 13.6666667,7 C13.8506667,7 14,6.85066667 14,6.66666667 C14,4.09333333 11.9066667,2 9.33333333,2 C9.14933333,2 9,2.14933333 9,2.33333333 C9,2.51733333 9.14933333,2.66666667 9.33333333,2.66666667 C11.5393333,2.66666667 13.3333333,4.46066667 13.3333333,6.66666667 Z"
                    />
                    <path
                      d="M9,4.33333333 C9,4.51733333 9.14933333,4.66666667 9.33333333,4.66666667 C10.436,4.66666667 11.3333333,5.564 11.3333333,6.66666667 C11.3333333,6.85066667 11.4826667,7 11.6666667,7 C11.8506667,7 12,6.85066667 12,6.66666667 C12,5.196 10.804,4 9.33333333,4 C9.14933333,4 9,4.14933333 9,4.33333333 Z"
                    />
                  </g>
                </svg>

                <span class="font-weight-light">22 33 33 40</span>
              </li>
            </ul>
            <div class="mt-2 font-weight-light text-small">
              <p>
                  YouWish.no sin kundeservice er åpen alle hverdager. Vi svarer vanligvis på e-post innen fire timer i åpningstiden.
              </p>
            </div>

            <div class="mt-3">
              <h6>Åpningstider</h6>

              <div class="w-50">
                <div v-for="workTime in workTimes" class="mb-1 d-flex justify-content-between font-weight-light text-small">
                  <div>{{workTime.day}}:</div>
                  <div>{{workTime.time}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-nav-text>
    </b-nav>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex';
import { users } from "@/api";

export default {
    name: 'sidebar',
    data() {
        return {
            currentRoute: 'home',
            quickGuideActive: false,
            accountInformationActive: false,
            knowledgeBaseActive: false,
            workTimes: [
                { day: 'Mandag', time: '11–14' },
                { day: 'Tirsdag', time: '11–14' },
                { day: 'Onsdag', time: '11–13' },
                { day: 'Torsdag', time: '13–15' },
                { day: 'Fredag', time: '13–15' },
            ],
        };
    },
    computed: {
        ...mapGetters({
            nextInvoiceCount: 'invoices/canBeInvoicedTable',
            user: 'auth/getUser',
        }),
        impersonator() {
            if (this.user && this.user.impersonator) {
                return this.user.impersonator.data.full_name;
            }
            return null;
        },
        isFAQActive() {
            return this.$route.path === '/vanlige' || this.$route.path === '/vanlige/';
        }
    },
    methods: {
        ...mapActions({
            logout: 'auth/doLogout',
        }),
        toggleAccountInformation() {
            this.accountInformationActive = !this.accountInformationActive;
        },
        toggleQuickGuide() {
            this.quickGuideActive = !this.quickGuideActive;
        },
        toggleKnowledgeBase() {
            this.knowledgeBaseActive = !this.knowledgeBaseActive;
        },
        handleOutsideClick(event) {
            if (this.$refs.faqItem && !this.$refs.faqItem.$el.contains(event.target)) {
                this.quickGuideActive = false;
            }
        },
        signOut() {
            this.logout();
            this.$router.push({ name: 'login' });
        },
        async backToUser() {
            await users.stopImpersonating();
            window.close();
        }
    },
    mounted() {
        document.addEventListener('click', this.handleOutsideClick);
        const faqPages = [
            '/supplier/verdibevis',
            '/supplier/oppgjoor',
            '/supplier/youwish-partner-portal',
            '/supplier/vanlige',
            '/supplier/vanlige/',
            '/supplier/login-og-flem-passord'
        ];
        if (faqPages.includes(window.location.pathname)) {
            this.quickGuideActive = true;
        }

        const knowledgeBasePages = [
            '/supplier/ok-salget-hos-youwish.no',
            '/supplier/opplevelsesprodukter',
            '/supplier/bookinger',
            '/supplier/policy-for-kunder'
        ];
        if (knowledgeBasePages.includes(window.location.pathname)) {
            this.knowledgeBaseActive = true;
        }

    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleOutsideClick);
    },
    watch: {
        $route(to) {
            this.currentRoute = to;
        },
    },
};
</script>

<style scoped>
.hoverable:hover {
    background-color: #dfe0e1;
    cursor: pointer;
}

.hoverable:hover span {
    background-color: transparent !important;
    font-weight: normal !important;
    text-decoration: none !important;
}
</style>
